import { render, staticRenderFns } from "./RatiosBySources.vue?vue&type=template&id=db6308b2&scoped=true&"
import script from "./RatiosBySources.vue?vue&type=script&lang=js&"
export * from "./RatiosBySources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6308b2",
  null
  
)

export default component.exports